import { formatTenantName } from '../../utils/tenant';

interface TenantNameProps {
    name: string;
}

const TenantName = ({ name }: TenantNameProps) => <>{formatTenantName(name)}</>;

export default TenantName;
